import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import useTimeZoneViewViewState, { TimeZoneViewProps } from '../viewstate/useTimeZoneViewViewState';
import loc from 'owa-localize';
import { timeZoneAriaLabel, timeZoneRemoveButtonAriaLabel } from '../clockStrings.locstring.json';

const removeButtonStyles: IButtonStyles = {
    root: styles.removeTimeZoneButton,
};

const removeButtonIconProps: IIconProps = {
    iconName: ControlIcons.Delete,
    styles: {
        root: styles.removeTimeZoneIcon,
    },
};

export default observer(function TimeZoneView(props: TimeZoneViewProps) {
    const {
        numTimeZones,
        containerAttributes,
        displayName,
        city,
        timeZoneShortName,
        timeZoneName,
        formattedDate,
        shouldShowRemove,
        removeButtonProps,
    } = useTimeZoneViewViewState(props);
    return (
        <div
            className={styles.timeZoneContainer}
            {...containerAttributes}
            data-is-focusable={true}
            role="listitem"
            aria-label={loc(timeZoneAriaLabel, city, timeZoneName, formattedDate)}
            aria-posinset={props.index + 1 /* props.index is zero-based */}
            aria-setsize={numTimeZones}>
            <div className={styles.timeZoneInfo}>
                <div className={styles.cityNameContainer}>
                    <div className={styles.cityName} title={displayName ?? city}>
                        {city ?? displayName}
                    </div>
                    {shouldShowRemove && (
                        <ActionButton
                            iconProps={removeButtonIconProps}
                            styles={removeButtonStyles}
                            {...removeButtonProps}
                            ariaLabel={loc(timeZoneRemoveButtonAriaLabel, city)}
                        />
                    )}
                </div>
                <div className={styles.timeZoneShortName} title={timeZoneName}>
                    {timeZoneShortName}
                </div>
            </div>
            <div>{formattedDate}</div>
        </div>
    );
});
